import React from 'react';
import LanguageQuestion from './languagequestion';
import MultiChoice from './multichoice';
import Message from './message';
import SubmitButton from './submitbutton';
import DateQuestion from './datequestion';
import _ from 'lodash';
import MultiChoiceImages from './multichoiceimages';
import { Modal, ModalMixin, ModalEventsMixin } from 'react-modal-box';
import reactMixin from 'react-mixin';
import MessageModal from './messagemodal';
import ThankYouMessage from './thankyoumessage';

import { getRespondentSurvey, updateRespondentSurvey } from '../api/respondentsurveyapi';

import './app.css';
import './searchbar.css';

const modalStyles = {
  modalBackdrop: {
    // Backdrop styles
  },
  modalContainer: {
    minWidth: 280,
    maxWidth: 560,
    maxHeight: '80%',
    width: '40%',
    padding: 0,
    backgroundColor: 'transparent'
  },
  modalDismiss: {
    visibility: 'collapse'
  },
  modalIcon: {
    // Default Icon styles, element inside the modal Dismiss
  }, 
  modalHeader: {
    margin: 0
  },
  modalContent: {
    margin: 0
  },
  modalFooter: {
    margin: 0
  }
};

class App extends React.Component {
	constructor(props) {
  	super(props);

  	this.state = {
  		respondentSurvey : null,
  		showThankYouMessage: false
  	};

  	this.onSubmit = this.onSubmit.bind(this);
  	this.onChangeAnswer = this.onChangeAnswer.bind(this);
	}

	componentDidUpdate() {
		document.title = this.state.respondentSurvey.title || 'SurveyBot';
	}

	componentDidMount() {
		getRespondentSurvey(this.id, this.reference, this.questionId)
		.then((respondentSurvey) => {
			//console.log('data: ' + JSON.stringify(respondentSurvey));
			this.setState({ respondentSurvey });

			if (respondentSurvey.answer.has_answer && respondentSurvey.actual_current_question_id != respondentSurvey.current_question.id) {
				const message = respondentSurvey.already_answered_error_message || 
					`You have already answered this question`;
				this.showMessage(message, () => {
					this.closeWindow();
				});
			}
		})
		.catch((err) => {
			this.showMessage(err.message);
		});
	}

	get id() {
		return this.props.match.params.id;
	}

	get reference() {
		return this.props.match.params.reference;
	}

	get questionId() {
		return this.props.match.params.question_id;
	}

	_createAnswer() {
		const respondentSurvey = this.state.respondentSurvey;
		const currentQuestion = respondentSurvey.current_question;
		
		const params = {
			question_id: currentQuestion.id,
			respondent_survey_id: respondentSurvey.id
		};

		return params;
	}

	showMessage(message, onResult) {
		const props = MessageModal.presets.simple;
		props.app = this;
		props.message = message;
		this.modalShow(
			<MessageModal {...props} onResult={onResult}/>
		);
	}

	validateAnswer() {
		const respondentSurvey = this.state.respondentSurvey;
		const currentQuestion = respondentSurvey.current_question;
		const answer = respondentSurvey.answer;
		if (currentQuestion.question_type === 'multi_choice') {
			if (currentQuestion.multi_answer) {
				if (currentQuestion.multi_choice_minimum > 0) {
					if (answer.multi_question_options_answer_ids.length < currentQuestion.multi_choice_minimum) {
						this.showMessage(`Please choose at least ${currentQuestion.multi_choice_minimum} options`);
						return false;	
					}
				}

				if (currentQuestion.multi_choice_maximum > 0) {
					if (answer.multi_question_options_answer_ids.length > currentQuestion.multi_choice_maximum) {
						this.showMessage(`Please choose no more than ${currentQuestion.multi_choice_maximum} options`);
						return false;	
					}
				}
				if (answer.multi_question_options_answer_ids.length === 0) {
					this.showMessage('Please select at least one option');
					return false;
				}
			}
		}

		return true;
	}

	onSubmit() {
		const respondentSurvey = this.state.respondentSurvey;
		const currentQuestion = respondentSurvey.current_question;
		const answer = respondentSurvey.answer;
		const ref = this.reference;

		if (!this.validateAnswer()) {
			return;
		}

		let params;
		// Update next question id only for messages
		if (currentQuestion.question_type === 'message') {
			params = { 
				ref
			};
		} else {
			const answers_attributes = [ this._serializeAnswer(answer) ];
			params = { 
				answers_attributes,
				ref 
			};	
		}

		this.setState({ showThankYouMessage: true });
		updateRespondentSurvey(respondentSurvey.id, params)
		.then(() => {
			this.closeWindow();
		})
		.catch((err) => {
			this.setState = { showThankYouMessage: false };
			this.showMessage(err.message);
		});
	}

	closeWindow() {
		const MessengerExtensions = window.MessengerExtensions;
		MessengerExtensions.requestCloseBrowser(function success() {}, function error(err) { console.log(err); });
	}

	_serializeAnswer(answer) {
		const copy = _.cloneDeep(answer);
		copy.answered_at = new Date();
		delete copy['date_content'];
		return copy;
	}

	get needsSubmit() {
		const respondentSurvey = this.state.respondentSurvey;
		const currentQuestion = respondentSurvey.current_question;

		if (currentQuestion.question_type === 'message') {
			return true;
		}

		if (currentQuestion.question_type === 'date' || 
			currentQuestion.question_type === 'datetime' || 
			currentQuestion.question_type === 'time') {
			return true;
		}

		if (currentQuestion.question_type === 'multi_choice' && currentQuestion.multi_answer) {
			return true;
		}

		return false;
	}

	render() {
		if (this.state.respondentSurvey == null) {
			return (
				<div>
					<Modal customStyles={modalStyles} />
				</div>
			);
		}

		const needsSubmit = this.needsSubmit;

		const submitButtonHeight = needsSubmit ? 60 : 0;
		const submitButton = needsSubmit ? (
			<div style={{
				position: 'absolute',
				left: 0,
				right: 0,
				bottom: 0,
				height: submitButtonHeight
			}}>
				<SubmitButton onClick={this.onSubmit} title={this.state.respondentSurvey.submit_question_button_text}/>
			</div> ) : null;

		if (this.state.showThankYouMessage) {
			return <ThankYouMessage title={this.state.respondentSurvey.answer_thank_you_message} />
		}

		return (
			<div style={{
				width: '100%',
				height: '100%',
				position: 'absolute',
				left: 0,
				right: 0,
				overflow: 'hidden'
			}}>
				<div style={{
					position: 'absolute',
					left: 0,
					right: 0,
					top: 0,
					bottom: submitButtonHeight,
					overflow: 'scroll'
				}}>
					{ this._renderCurrentQuestion() }
				</div>
				{submitButton}
				<Modal customStyles={modalStyles} />
			</div>
		);
	}

	onChangeAnswer(answer) {
		const respondentSurvey = this.state.respondentSurvey;
		respondentSurvey.answer = answer;
		this.setState({ respondentSurvey });

		if (!this.needsSubmit) {
			this.onSubmit();
		}
	}

	_renderCurrentQuestion() {
		const respondentSurvey = this.state.respondentSurvey;
		const currentQuestion = respondentSurvey.current_question;
		const answer = respondentSurvey.answer;

		if (currentQuestion.question_type === 'multi_choice') {
			if (currentQuestion.question_options.length > 0 && currentQuestion.question_options[0].image_url != null) {
				return <MultiChoiceImages question={currentQuestion} answer={answer} onChangeAnswer={this.onChangeAnswer} />	
			} else {
				return <MultiChoice question={currentQuestion} answer={answer} onChangeAnswer={this.onChangeAnswer} />	
			}
		} else if (currentQuestion.question_type == 'language') {
			return <LanguageQuestion question={currentQuestion} answer={answer} onChangeAnswer={this.onChangeAnswer} />
		} else if (
			currentQuestion.question_type === 'date' || 
			currentQuestion.question_type === 'datetime' || 
			currentQuestion.question_type === 'time') {
			return <DateQuestion question={currentQuestion} answer={answer} onChangeAnswer={this.onChangeAnswer}/>
		} 
	}
}

reactMixin(App.prototype, ModalMixin);
reactMixin(App.prototype, ModalEventsMixin);

export default App;



// WEBPACK FOOTER //
// ./src/components/app.jsx